<template>
  <div id="app">
    <Navbar />
    <Sidebar />
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Sidebar from '@/components/Sidebar.vue';
import store from '@/plugins/vuex';

export default defineComponent({
  name: 'App',
  components: {
    Navbar,
    Sidebar,
  },
  mounted() {
    store.dispatch.task.loadList();
  },
});
</script>
